<template>
  <div class="adv">
    <!-- 轮播图 -->
    <div class="banner">
      <div class="img">
        <img src="@/assets/imgs/collection.jpg" alt="" class="image" />
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 导航内容 -->
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">

          <el-breadcrumb-item>馆藏鉴赏</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <!-- 中兴内容 -->
    <div class="art">
      <!-- 版心内容 -->
      <div class="art-cont">
        <div class="art-tit">馆藏分类</div>
        <!-- 藏品展示区域 -->
        <div class="art-box">
          <div
            class="art-list pos"
            v-for="inf in infoDataY"
            :alt="inf.title"
            :key="inf.museumCollectionClassifyId"
            @click="watchDetail(inf)"
            :style="{ backgroundImage: 'url(\'' + inf.bgImg + '\')' }"
          >
            <div class="small">{{ inf.categoryName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script scoped>
import axios from "axios";
// 馆藏分类
export default {
  data() {
    return {
      infoDataY: [],
      informationData: [],
      arr: [],
      imgIg: [],
    };
  },
  mounted() {},
  created() {
    this.getList().then((res) => {
      this.getImgList(res);
    });
  },
  methods: {
    async getList() {
      let res = await this.$axios({
        method: "get",
        url: "/frontapi/museumCollection/classify/list",
        params: {
          status: 0,
        },
        data: {},
      });
      let arr = [];
      this.infoDataY = undefined;
      this.infoDataY = new Array();
      this.infoDataY = this.infoDataY;
      console.log(11111);
      console.log(this.infoDataY);
      console.log(222222222222);
      let length = res.data.rows.length;
      console.log(res.data.rows);
      for (let i = 0; i < length; i++) {
        console.log(res.data.rows[i].params.reallyFilePath);
        let obj = {};
        obj.title = res.data.rows[i].title;
        obj.categoryName = res.data.rows[i].categoryName;
        obj.categoryId = res.data.rows[i].categoryId;
        obj.imgId = res.data.rows[i].imgId;
        obj.reallyFilePath = res.data.rows[i].params.reallyFilePath;
        console.log(this.infoDataY);
        this.infoDataY.push(obj);
      }
      console.log(this.infoDataY, "this is infoDataY");
      this.$forceUpdate();
      return this.infoDataY;
    },
    getImgList(arr) {
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        console.log(i + "---------------------------");
        let obj = {};

        console.log(arr, "this arr");
        let bgImg = axios.defaults.baseURL + arr[i].reallyFilePath;
        this.$set(arr[i], "bgImg", bgImg);
        // this.$set(arr[i],'bgImg',bgImg);
        // this.getAttachment(arr[i].imgId).then((data)=>{
        //    let bgImg = axios.defaults.baseURL + data;
        //    this.$set(arr[i],'bgImg',bgImg);
        // });
      }
      console.log(arr, "this is arr");
    },
    unique(arr) {
      let result = {};
      let finalResult = [];
      for (let i = 0; i < arr.length; i++) {
        result[arr[i].month] = arr[i];
        // arr[i].month 不能重复,达到去重效果,且这里必须知晓"month"或是其他键名
      }
      // console.log(result);
      for (const item in result) {
        finalResult.push(result[item]);
      }
      // console.log(finalResult);
      return finalResult; //要返回的数据
    },
    async getAttachment(id) {
      var info = await this.$axios({
        method: "get",
        url: "/common/fileInfo/" + id,
        data: {},
      });
      return info.data.data[0].filePath;
    },
    watchDetail(selObj) {
      console.log(selObj);
      console.log(selObj.categoryId);
      this.$router.push({
        path: "/appreciate/collectionList",
        query: { id: selObj.categoryId, name: selObj.categoryName },
      });
    },
  },
};
</script>
<style scoped>
img {
  font-size: 18px;
}
.nav >>> .el-breadcrumb__inner.is-link {
  font-weight: 500;
  text-decoration: none;
  color: #606266;
}
/* *{margin: 0;padding: 0;} */
i {
  font-style: normal;
}
.adv {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  padding-top: 1.111111rem /* 80px -> 1.111111rem */;
}
.banner {
  width: 100%;
  height: auto;
}
.banner .img img {
  width: 100%;
  height: auto;
}
.image {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  padding-top: 60px;
}
.nav {
  font-size: 18px;
    width: 1199px;
  height: 18px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.about >>> .nav {
  cursor: pointer;
}
.about >>> .is-link {
  font-weight: 400;
  color: #606266;
  /* cursor: text; */
}
.nav >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.art {
  height: 1349px;
  width: 100%;
}
.small {
  position: absolute;
  width: 180px;
  height: 40px;
  background: #b78c0d;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 18px;
  left: 55px;
  bottom: 30px;
}
.pos {
  position: relative;
  cursor: pointer;
}
.abt {
  position: absolute;
}
.art-cont {
  width: 1200px;
  height: 1269px;
  background: #fff;
  padding-top: 29px;
  margin: 0 auto;
  /* background: pink; */
  border-radius: 10px;
}
.art-tit {
  width: 100%;
  height: 30px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  text-align: center;
  margin-bottom: 30px;
}
.art-box {
  height: 1140px;
  width: 1140px;
  /* background: pink; */
  margin: 0 auto;
  overflow: auto;
}
.art-one {
  display: flex;
  width: 100%;
  height: 360px;
  margin-bottom: 30px;
  justify-content: space-between;
}

.art-list {
  /* width: 360px;
  height: 360px; */
  width: 285px;
  height: 320px;
  float: left;
  /* margin: 16px 0 0 16px; */
  margin-left: 75px;
  margin-bottom: 32px;
  border-radius: 10px;
  /* background-image: url('../../assets/imgs/国画.png'); */
  background-size: 100% 100%;
}

.art-list img {
  float: left;
  width: 200px;
  height: 260px;
}

.art-a {
  width: 360px;
  height: 360px;
  background-image: url("../../assets/imgs/国画.png");
  background-size: 100% 100%;
}
.art-b {
  width: 360px;
  height: 360px;
  background-image: url("../../assets/imgs/油画.png");
  background-size: 100% 100%;
}
.art-c {
  width: 360px;
  height: 360px;
  background-image: url("../../assets/imgs/版画.png");
  background-size: 100% 100%;
}
.art-d {
  width: 360px;
  height: 360px;
  background-image: url("../../assets/imgs/水彩画.png");
  background-size: 100% 100%;
}
.art-e {
  width: 360px;
  height: 360px;
  background-image: url("../../assets/imgs/摄影.png");
  background-size: 100% 100%;
}
.art-f {
  width: 360px;
  height: 360px;
  background-image: url("../../assets/imgs/书法.png");
  background-size: 100% 100%;
}
.art-g {
  width: 360px;
  height: 360px;
  background-image: url("../../assets/imgs/民间工艺.png");
  background-size: 100% 100%;
  margin-right: 30px;
}
.art-h {
  width: 360px;
  height: 360px;
  background-image: url("../../assets/imgs/综合材料.png");
  background-size: 100% 100%;
}
.art-two {
  display: flex;
  width: 100%;
  height: 360px;
  margin-bottom: 30px;
}
</style>
